export default "__VITE_ASSET__c8e3ed61__"